export const SESSION_TRACK_ACCESS_DENIED_MESSAGE = 'You do not have access to this session track.';
